export enum ModelType {
  ObjectModel = 1001,
  ObjectModelProperty = 1101,

  ObjectModelRelation = 2001,

  ContentListView = 3001,
  ContentDetailView = 3002,

  Form = 4001,
  FormElement = 4101,
  LookUpField = 4102,
  WorkflowStep = 4201,
  PaymentStep = 4202,
  PaymentStepLineItem = 4203,
  WorkflowStepAction = 4204,
  FormSection = 4301,

  License = 5001,

  Portal = 6001,

  Certificate = 7001,
  CertificateDynamicInput = 7002,

  Mapping = 8001,
  RelationIdentifier = 8002,

  PublicProfile = 9001,

  SObject = 10001,
  SObjectReferenceField = 10002,
  SObjectChildRelationship = 10003,

  EntityType = 11001,

  ProcessFlow = 12001,
  ProcessFlowVariable = 12002,

  // Generic types - first usage is in Process Flow for variable type
  File = 13001,
  Text = 13002,
  Object = 13003,
  DateTime = 13004,
  Array = 13005,
  Number = 13006,
  Boolean = 13007,

  EndPoint = 14001,
  API = 15001,
  DynamicInput = 15002,
  APIMessageType = 15003,

  User = 16001,
  FormabilityUser = 16002,
  PortalUser = 16003,

  Email = 17001,

  UserType = 18001,

  Dashboard = 19001,

  Signature = 20001,

  Folder = 21001,

  Visualization = 22001,
}

export let ModelTypeDisplay: { [key in ModelType]?: string } = {
  [ModelType.ObjectModel]: 'Object Model',
  [ModelType.ObjectModelRelation]: 'Object Model Relation',
  [ModelType.ContentListView]: 'List View',
  [ModelType.ContentDetailView]: 'Detail View',
  [ModelType.Form]: 'Form',
  [ModelType.License]: 'License',
  [ModelType.Portal]: 'Portal',
  [ModelType.Certificate]: 'Document',
  [ModelType.Mapping]: 'Mapping',
  [ModelType.PublicProfile]: "Public Profile",
  [ModelType.EntityType]: "Entity Type",
  [ModelType.ProcessFlow]: "Process Flow",
  [ModelType.Visualization]: "Visualization",
  [ModelType.EndPoint]: "Endpoint",
  [ModelType.API]: "API",
  [ModelType.Number]: "Number",
  [ModelType.Boolean]: "Boolean",
  [ModelType.User]: "User",
  [ModelType.Email]: "Email",
  [ModelType.UserType]: 'User Type',
  [ModelType.Dashboard]: 'Dashboard',
  [ModelType.DynamicInput]: 'Sub-object',
  [ModelType.Folder]: 'Folder',
};

// add to as needed
export const ModelTypeIcon: { [key in ModelType]?: string } = {
  [ModelType.Text]: 'text',
  [ModelType.File]: 'file',
  [ModelType.DateTime]: 'datepicker',
  [ModelType.Number]: 'numbers',
  [ModelType.Boolean]: 'toggle',
  [ModelType.Email]: 'text',
  [ModelType.Form]: 'form',
  [ModelType.License]: 'license',
  [ModelType.Certificate]: 'certificate',
  [ModelType.PublicProfile]: 'public-profile',
  [ModelType.Folder]: 'folder-closed',
};

/**
 * key is the destination, value is an array of sources that can go into the destination and assume that shape
 * this map is certainly not an all-inclusive determination of one type of data being compatible with another
 * @example ModelType.Form is compatible with ModelType.Form but additional checks need to be made to make sure
 *   the shape of each side (Form) is compatible (likely in this case by checking the ids are the same)
 *
 * Fill in the rest as needed
 */
export function ModelTypeCompatibilityMap(modelType: ModelType): readonly ModelType[] {
  let compatibles: ModelType[] = [modelType] // everything is compatible with itself
  if (modelType === ModelType.Text) {
    compatibles.push(ModelType.DateTime, ModelType.Number, ModelType.Email, ModelType.User)
  } else if (modelType === ModelType.User) {
    compatibles.push(ModelType.Email)
  } else if (modelType === ModelType.Email) {
    compatibles.push(ModelType.User)
  }
  return compatibles
}
